module.exports = __webpack_public_path__ + "6e09b3bf140c50b3c7e9fca22a56c8ae.png";